import React from "react";
import { css } from "@emotion/react";
import { Link } from "gatsby";

type FrontMatter = {
  date?: string;
  title?: string;
  description?: string;
  tags?: (string | undefined)[];
};

type Post = {
  frontmatter?: FrontMatter;
  fields?: { slug?: string };
  excerpt?: string;
};

type Props = {
  posts: Post[];
};

export const PostList: React.FC<Props> = React.memo(({ posts }) => {
  return (
    <ol style={{ listStyle: `none` }}>
      {posts.map(post => {
        const title = post.frontmatter?.title || post.fields?.slug;

        return (
          <li key={post.fields?.slug}>
            <article className="post-list-item" itemScope itemType="http://schema.org/Article">
              <header>
                <h2>
                  <Link to={post.fields?.slug || "404"} itemProp="url">
                    <span itemProp="headline">{title}</span>
                  </Link>
                </h2>
                <small>{post.frontmatter?.date}</small>
              </header>
              <section>
                <p
                  dangerouslySetInnerHTML={{
                    __html: post.frontmatter?.description || post.excerpt || "",
                  }}
                  itemProp="description"
                  css={bodyAbstractStyle}
                />
              </section>
            </article>
          </li>
        );
      })}
    </ol>
  );
});

const bodyAbstractStyle = css({
  fontSize: "14px",
});
